// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrophyTwoToneSvg from "@fishx/icons-svg/es/asn/TrophyTwoTone";
import FishxIcon from '../components/FishxIcon';

var TrophyTwoTone = function TrophyTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrophyTwoToneSvg
  }));
};

TrophyTwoTone.displayName = 'TrophyTwoTone';
export default React.forwardRef(TrophyTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrophyTwoTone.js
// module id = 4289
// module chunks = 0